<template>
  <div>
    <!-- <FITModal ref="deleteClaimModal" reference="modal" :title="$t('osm..delete.header')" @click="onClickModalDelete">
      <div slot="body">
        <span v-html="$t('osm.Claim.delete.confirmDelete', {ClaimCode: clickedRow.ClaimCode, ClaimChineseName: clickedRow.ClaimChineseName, ClaimEnglishName: clickedRow.ClaimEnglishName})"></span>
      </div>
    </FITModal> -->
    <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>{{$t('osm.claim.list.header')}}</h4>
          </b-col>
          <b-col cols="6" class="text-right" v-if="isReport">
          <b-button variant="success" size="md" @click="exportReport">{{ $t('dw.general.export') }}</b-button>
        </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable @onRowSelected="onRowSelected" ref="table" :filters="filters" vuexModule="Claim" searchAction="getClaimList" :columns="columns" type="claim" v-model="currentFilters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITSearchableTable, FITFormCard, FITAlert, FITModal, FITAutoSearch } from '@/components'
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver/FileSaver';
export default {
  name: 'ClaimList',
  props: {
    alertContent: {
      type: String,
      default: null
    },
    alertVariant: {
      type: String,
      default: null
    },

    isReport: {
      type: Boolean,
      default: false
    }

  },
  mounted() {
    if (this.alertContent) {
      this.setAlert();
      this.$refs.alert.showAlert();
    }
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
  },
  methods: {
     exportReport() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));
      filters.export = 1
      var params = this.$options.filters.removeEmptyObj(filters);
      console.debug(params);

      this.$store.dispatch('Dw/exportClaimReport', params).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        var blob = new Blob([json.data]);
        saveAs(blob, fileName);
      })
    },
    generateClaimStatusDom(status, translatedStatus) {
      let icon = '';
      let text = 'danger';
      switch (status.toLowerCase()) {
        case 'a':
          icon = 'fa-check'
          text = 'success'
          break;
        case 'c':
          icon = 'fa-check-double'
          text = 'primary'
          break;
        case 'p':
          icon = 'fa-ellipsis-h'
          text = 'warning'
          break;
        case 'r':
          icon = 'fa-times-circle'
          text = 'danger'
          break;
      }
      return `<span class="text-${text}"><i class="fa ${icon} mr-2"></i>${translatedStatus}</span>`;
    },
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Claim', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
    setAlert() {
      if (this.alertContent) {
        Vue.set(this.alertParams, 'content', this.alertContent);
      }
      if (this.alertVariant) {
        Vue.set(this.alertParams, 'variant', this.alertVariant);
      }
    },
    createClaim() {
      this.$router.push({
        name: 'Create Claim'
      })
    },
    onRowSelected(row) {
      if (this.isReport) {
        return;
      }
      this.$store.commit({ type: 'Claim/setNextWorkFlowStep', nextStep: parseInt(row.workFlowStep) });
      this.$store.commit({ type: 'Claim/setClaimID', ID: parseInt(row.ID) });
      switch (row.status) {
        case 'R':
        case 'C':
          this.$router.push({
            name: 'Claim Detail',
            params: { detail: row }
          })
          break;
        default:
          this.$router.push({
            name: 'Create Claim',
            params: { detail: row, ClaimHeader: this.$t('osm.Claim.edit.header') }
          });
          break;
      }
    },
    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('Claim/deleteClaim', this.clickedRow.ID).then((json) => {
        this.$refs.table.search();
        this.$refs.deleteClaimModal.closeModal();
        Vue.set(this, 'alertParams', { content: this.$t('general.deleteSuccess'), variant: 'success' });
        this.$refs.alert.showAlert();
      })
    },
  },
  data() {
    return {
      currentFilters:{},
      clickedRow: {
        ClaimCode: 'N/A',
        ClaimEnglishName: 'N/A',
        ClaimChineseName: 'N/A'
      },
      alertParams: {
        content: '<strong>Success</strong>',
        variant: 'success'
      },
      columns: [
        { key: 'policyReference', label: this.$t('osm.claim.policyReference'), sortable: true, },
        {
          key: 'policyType',
          label: this.$t('osm.claim.policyType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated(key, row)
          }
        },
        {
          key: 'serviceAgentEnglishName',
          label: this.$t('osm.claim.agentName'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(item.serviceAgentEnglishName) + "</br>" + this.$options.filters.isEmpty(item.serviceAgentChineseName);
          }
        },
        {
          key: 'agentCode',
          label: this.$t('osm.claim.agentCode'),
          sortable: true,
        },
        {
          key: 'serviceAgentEnglishName',
          label: this.$t('osm.claim.agentName'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(item.serviceAgentEnglishName) + "</br>" + this.$options.filters.isEmpty(item.serviceAgentChineseName);
          }
        },
        {
          key: 'claimType',
          label: this.$t('osm.claim.claimType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        {
          key: 'expectedClaimAmount',
          label: this.$t('osm.claim.expectedClaimAmount'),
          sortable: true,
          thClass: ['bulletin-time', 'text-center'],
          tdClass: ['text-center'],
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'status',
          label: this.$t('osm.claim.status'),
          sortable: true,
          thClass: ['bulletin-time', 'text-center'],
          tdClass: ['text-center'],
          formatter: (row, key, item) => {
            return this.generateClaimStatusDom(row, this.getTranslated(key, row))
          }
        }, { key: 'updateTime', label: this.$t('osm.claim.updateTime'), sortable: true },
      ],
      filters: [{
        label: this.$t('osm.claim.policyType'),
        key: 'policyType',
        type: 'select',
        default: null,
      }, {
        label: this.$t('osm.claim.claimType'),
        key: 'claimType',
        type: 'select',
        default: null,
      }, {
        label: this.$t('osm.claim.status'),
        key: 'status',
        type: 'select',
        default: null,
      }],
    }
  },
  components: {
    FITSearchableTable,
    FITFormCard,
    FITAlert,
    FITModal,
    FITAutoSearch
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/Claim/containers/ClaimList.vue